import { ProductType, PRODUCTS, UnitCategoryCode } from 'cart-model';
import { EventType } from 'common-event';
import React, { FunctionComponent, useEffect } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { ReactComponent as InvestingIcon } from '../../assets/images/target.svg';
import { ReactComponent as PensionIcon } from 'common-assets/assets/icons/pig.svg';
import { ReactComponent as Medal } from '../../assets/images/medal.svg';
import { ReactComponent as Cup } from '../../assets/images/cup.svg';
import { logEvent, logSelectProduct } from '../../model/events';
import { productWizardActions } from '../../model/store';
import Screen from '../ProductWizard/Screen';
import { ChoiceSteps } from '../ChoiceSteps/ChoiceSteps';
import { ChoiceOption } from '../ChoiceSteps/ChoiceSteps.types';
import { InfoNoteData } from '../InfoNote/InfoNote.types';
import { getDecorationIconWcagProps } from 'ui-components';
import useGetAvailableFundsByUnitCategory from '../../model/useGetAvailableFundsByUnitCategory';
import ProductWizardState from '../../model/ProductWizardState';

const SaveOrInvest: FunctionComponent<{
}> = () => {
  const dispatch = useDispatch();
  const [t] = useTranslation('save-or-invest');
  const getAvailableFundsForUnitCategory = useGetAvailableFundsByUnitCategory();
  const productType = useSelector((state: ProductWizardState) => state.uiState.productType);

  const setProductType = (value: ProductType) => {
    dispatch(productWizardActions.setProductType(value));
    dispatch(productWizardActions.setSelectedTypeOfInvestment({selectedTypeOfInvestment: value}));
  };
  const unitCategoryCode = productType ? PRODUCTS[productType]?.unitCategory : UnitCategoryCode.A;
  const fundCounter = getAvailableFundsForUnitCategory(unitCategoryCode).length;

  const options: ChoiceOption[] = [
    {
      title: t('save.title'),
      subtitle: t('save.subtitle'),
      icon: <PensionIcon {...getDecorationIconWcagProps()}/>,
      path: Screen.IKE_OR_IKZE.code,
      onClick: () => {
        dispatch(productWizardActions.setIsPensionProcess(true));
        logSelectProduct('retirement');
      }
    },
    {
      title: t('invest.title'),
      subtitle: t('invest.subtitle', { fundsCount: fundCounter }),
      icon: <InvestingIcon {...getDecorationIconWcagProps()}/>,
      path: Screen.SELECT_PATH.code,
      onClick: () => {
        setProductType(ProductType.funds);
        dispatch(productWizardActions.setIsPensionProcess(false));
        logSelectProduct('investment');
      }
    }
  ];

  const notes: InfoNoteData[] = [
    {
      title: t('save.note.title'),
      subtitle: <Trans
        i18nKey="save.note.subtitle"
        ns="save-or-invest"
      >
        <br/>
        <></>
      </Trans>,
      icon: <Medal {...getDecorationIconWcagProps()}/>
    },
    {
      title: t('invest.note.title'),
      subtitle: t('invest.note.subtitle'),
      icon: <Cup {...getDecorationIconWcagProps()}/>
    }
  ];

  useEffect(() => logEvent(EventType.startStart), []);

  return (
    <ChoiceSteps
      titleKey={Screen.SAVE_OR_INVEST.code}
      options={options}
      notes={notes}
    />
  );
};

export default SaveOrInvest;
